(() => {
  'use strict';

  const FORM_SELECTOR = [
    'form.cntrip-ticket-safe__form',
    'form.cntrip-day-tour-safe__form',
    'form.cntrip-huaqing-safe__form',
    'form.cntrip-private-tour-safe__form',
  ].join(',');

  const VARIANT_SELECT_SELECTOR = [
    '[data-ticket-variant]',
    '[data-day-tour-variant]',
    '[data-huaqing-variant]',
    '[data-private-tour-variant]',
  ].join(',');

  const TYPE_PATTERNS = {
    adult: /(^|\s|[-–—/])(adult|adults)(\s|$|[-–—/])|成人/i,
    child: /(^|\s|[-–—/])(child|children|kid|kids|youth)(\s|$|[-–—/])|儿童|小童|青少年/i,
  };

  function addStyles() {
    if (document.getElementById('cntrip-multi-traveler-styles')) return;

    const style = document.createElement('style');
    style.id = 'cntrip-multi-traveler-styles';
    style.textContent = `
      .cntrip-traveler-picker{margin:16px 0 4px;padding:16px;border:1px solid #d8e2ef;border-radius:14px;background:#f8fbff}
      .cntrip-traveler-picker__heading{margin:0 0 10px;color:#14213d;font-size:13px;font-weight:800}
      .cntrip-traveler-picker__rows{display:grid;gap:10px}
      .cntrip-traveler-picker__row{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:14px;align-items:center;padding:13px 14px;border:1px solid #dce6f2;border-radius:12px;background:#fff}
      .cntrip-traveler-picker__row.is-unavailable{opacity:.58;background:#f4f5f7}
      .cntrip-traveler-picker__name{display:block;color:#14213d;font-size:14px;font-weight:800;line-height:1.35}
      .cntrip-traveler-picker__price{display:block;margin-top:3px;color:#5f6b7a;font-size:12px;line-height:1.35}
      .cntrip-traveler-picker__stepper{display:grid;grid-template-columns:38px 52px 38px;align-items:center;overflow:hidden;border:1px solid #cbd5e1;border-radius:10px;background:#fff}
      .cntrip-traveler-picker__stepper button{width:38px;height:42px;padding:0;border:0;background:#f3f7fc;color:#0b49b8;font:800 20px/1 Arial,sans-serif;cursor:pointer}
      .cntrip-traveler-picker__stepper button:hover:not(:disabled){background:#e7f0fd}
      .cntrip-traveler-picker__stepper input{width:52px!important;min-height:42px!important;height:42px!important;margin:0!important;padding:0 4px!important;border:0!important;border-inline:1px solid #d7e0eb!important;border-radius:0!important;background:#fff!important;color:#14213d!important;text-align:center;font-weight:800;-moz-appearance:textfield}
      .cntrip-traveler-picker__stepper input::-webkit-inner-spin-button,.cntrip-traveler-picker__stepper input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}
      .cntrip-traveler-picker__stepper button:disabled,.cntrip-traveler-picker__stepper input:disabled{cursor:not-allowed;opacity:.6}
      .cntrip-traveler-picker__helper{margin:9px 0 0;color:#5f6b7a;font-size:12px;line-height:1.5}
      .cntrip-traveler-picker__error{display:none;margin:10px 0 0;padding:10px 12px;border:1px solid #efb6b6;border-radius:9px;background:#fff2f2;color:#9b1c1c;font-size:12px;line-height:1.45}
      .cntrip-traveler-picker__error.is-visible{display:block}
      .cntrip-form-grid--single{grid-template-columns:1fr!important}
      @media(max-width:480px){.cntrip-traveler-picker{padding:13px}.cntrip-traveler-picker__row{gap:10px;padding:12px}.cntrip-traveler-picker__stepper{grid-template-columns:34px 46px 34px}.cntrip-traveler-picker__stepper button{width:34px}.cntrip-traveler-picker__stepper input{width:46px!important}}
    `;
    document.head.appendChild(style);
  }

  function travelerType(option) {
    const text = `${option.textContent || ''} ${option.value || ''}`.trim();
    if (TYPE_PATTERNS.adult.test(text)) return 'adult';
    if (TYPE_PATTERNS.child.test(text)) return 'child';
    return null;
  }

  function cleanTitle(option, fallback) {
    const raw = (option.textContent || '').trim();
    const withoutPrice = raw.split(/\s+[—–]\s+/)[0].trim();
    return withoutPrice || fallback;
  }

  function createStepper(option, type) {
    const available = Boolean(option) && option.dataset.available !== 'false' && !option.disabled;
    const row = document.createElement('div');
    row.className = `cntrip-traveler-picker__row${available ? '' : ' is-unavailable'}`;
    row.dataset.cntripTravelerRow = type;

    const info = document.createElement('div');
    const name = document.createElement('strong');
    name.className = 'cntrip-traveler-picker__name';
    name.textContent = option ? cleanTitle(option, type === 'adult' ? 'Adult' : 'Child') : (type === 'adult' ? 'Adult' : 'Child');

    const price = document.createElement('span');
    price.className = 'cntrip-traveler-picker__price';
    price.textContent = available ? (option.dataset.price || '') : 'Currently unavailable';
    info.append(name, price);

    const stepper = document.createElement('div');
    stepper.className = 'cntrip-traveler-picker__stepper';

    const minus = document.createElement('button');
    minus.type = 'button';
    minus.textContent = '−';
    minus.setAttribute('aria-label', `Decrease ${type} quantity`);
    minus.dataset.cntripQuantityAction = 'minus';

    const input = document.createElement('input');
    input.type = 'number';
    input.min = '0';
    input.step = '1';
    input.value = type === 'adult' && available ? '1' : '0';
    input.inputMode = 'numeric';
    input.setAttribute('aria-label', `${type === 'adult' ? 'Adult' : 'Child'} quantity`);
    input.dataset.cntripTravelerQuantity = type;
    input.dataset.variantId = option?.value || '';
    input.dataset.travelerType = type === 'adult' ? 'Adult' : 'Child';
    input.dataset.available = String(available);

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.textContent = '+';
    plus.setAttribute('aria-label', `Increase ${type} quantity`);
    plus.dataset.cntripQuantityAction = 'plus';

    if (!available) {
      minus.disabled = true;
      input.disabled = true;
      plus.disabled = true;
    }

    stepper.append(minus, input, plus);
    row.append(info, stepper);
    return row;
  }

  function showError(form, message) {
    const error = form.querySelector('[data-cntrip-multi-error]');
    if (!error) return;
    error.textContent = message;
    error.classList.add('is-visible');
    error.setAttribute('role', 'alert');
  }

  function clearError(form) {
    const error = form.querySelector('[data-cntrip-multi-error]');
    if (!error) return;
    error.textContent = '';
    error.classList.remove('is-visible');
    error.removeAttribute('role');
  }

  function collectProperties(form) {
    const properties = {};
    const data = new FormData(form);

    for (const [key, value] of data.entries()) {
      const match = key.match(/^properties\[(.+)]$/);
      if (!match || typeof value !== 'string') continue;
      const cleaned = value.trim();
      if (cleaned) properties[match[1]] = cleaned;
    }

    properties['_Confirmation status'] = 'Booking request';
    properties['_Party reference'] = `cntrip-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    return properties;
  }

  function cartRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  async function submitMultipleTravelers(form, event) {
    event.preventDefault();
    event.stopPropagation();
    clearError(form);

    if (!form.reportValidity()) return;

    const quantityInputs = Array.from(form.querySelectorAll('[data-cntrip-traveler-quantity]'));
    const selected = quantityInputs
      .map((input) => ({
        input,
        id: input.dataset.variantId || '',
        quantity: Math.max(0, Math.floor(Number(input.value) || 0)),
        travelerType: input.dataset.travelerType || 'Traveler',
        available: input.dataset.available === 'true',
      }))
      .filter((item) => item.quantity > 0);

    if (!selected.length) {
      showError(form, 'Select at least one adult or child traveler.');
      return;
    }

    const unavailable = selected.find((item) => !item.available || !item.id);
    if (unavailable) {
      showError(form, `${unavailable.travelerType} tickets are currently unavailable.`);
      return;
    }

    const sharedProperties = collectProperties(form);
    const items = selected.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      properties: {
        ...sharedProperties,
        '_Traveler type': item.travelerType,
      },
    }));

    const submit = form.querySelector('button[type="submit"]');
    const originalText = submit?.dataset.cntripOriginalText || submit?.textContent?.trim() || 'Add to Booking Cart';

    if (submit) {
      submit.dataset.cntripOriginalText = originalText;
      submit.disabled = true;
      submit.textContent = 'Adding to booking cart…';
    }

    try {
      const response = await fetch(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'Unable to add the selected tickets.');
      }

      window.location.assign(`${cartRoot()}cart`);
    } catch (error) {
      showError(form, error instanceof Error ? error.message : 'Unable to add the selected tickets. Please try again.');
      if (submit) {
        submit.disabled = false;
        submit.textContent = originalText;
      }
    }
  }

  function wireStepper(picker) {
    picker.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-cntrip-quantity-action]');
      if (!(button instanceof HTMLButtonElement) || button.disabled) return;

      const input = button.parentElement?.querySelector('[data-cntrip-traveler-quantity]');
      if (!(input instanceof HTMLInputElement)) return;

      const current = Math.max(0, Math.floor(Number(input.value) || 0));
      input.value = String(button.dataset.cntripQuantityAction === 'plus' ? current + 1 : Math.max(0, current - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initForm(form) {
    if (!(form instanceof HTMLFormElement) || form.dataset.cntripMultiTravelerInitialized === 'true') return;

    const select = form.querySelector(VARIANT_SELECT_SELECTOR);
    const nativeQuantity = form.querySelector('input[name="quantity"]');
    if (!(select instanceof HTMLSelectElement) || !(nativeQuantity instanceof HTMLInputElement)) return;

    const options = Array.from(select.options);
    const adultOption = options.find((option) => travelerType(option) === 'adult');
    const childOption = options.find((option) => travelerType(option) === 'child');
    if (!adultOption) return;

    form.dataset.cntripMultiTravelerInitialized = 'true';
    form.dataset.cntripMultiTravelerReady = 'true';

    const picker = document.createElement('div');
    picker.className = 'cntrip-traveler-picker';
    picker.dataset.cntripTravelerPicker = 'true';

    const heading = document.createElement('p');
    heading.className = 'cntrip-traveler-picker__heading';
    heading.textContent = form.classList.contains('cntrip-ticket-safe__form') ? 'Ticket quantities' : 'Traveler quantities';

    const rows = document.createElement('div');
    rows.className = 'cntrip-traveler-picker__rows';
    rows.append(createStepper(adultOption, 'adult'), createStepper(childOption, 'child'));

    const helper = document.createElement('p');
    helper.className = 'cntrip-traveler-picker__helper';
    helper.textContent = childOption
      ? 'Adult and child quantities are added together in one booking request.'
      : 'A child rate is not configured for this product. Contact CNTrip before booking children.';

    const error = document.createElement('p');
    error.className = 'cntrip-traveler-picker__error';
    error.dataset.cntripMultiError = 'true';
    error.setAttribute('aria-live', 'polite');

    picker.append(heading, rows, helper, error);

    const originalLabel = Array.from(form.querySelectorAll('label[for]')).find((label) => label.htmlFor === select.id);
    (originalLabel || select).insertAdjacentElement('beforebegin', picker);
    originalLabel?.remove();
    select.remove();

    const quantityWrapper = nativeQuantity.parentElement;
    const formGrid = quantityWrapper?.parentElement;
    quantityWrapper?.remove();
    if (formGrid && formGrid.children.length === 1) formGrid.classList.add('cntrip-form-grid--single');

    const oldHelper = form.querySelector('.cntrip-private-tour-safe__helper');
    if (oldHelper) oldHelper.remove();

    const huaqingFootnote = form.querySelector('.cntrip-huaqing-safe__footnote');
    if (huaqingFootnote) {
      huaqingFootnote.textContent = 'Adult and child quantities are added together. Wait for the confirmed tour format, pickup details, itinerary and voucher before departure.';
    }

    const submit = form.querySelector('button[type="submit"]');
    const availableInputs = picker.querySelectorAll('[data-cntrip-traveler-quantity]:not(:disabled)');
    if (submit) {
      if (availableInputs.length) {
        submit.disabled = false;
        if (/currently unavailable/i.test(submit.textContent || '')) {
          submit.textContent = form.classList.contains('cntrip-ticket-safe__form') ? 'Request ticket' : 'Add to Booking Cart';
        }
      } else {
        submit.disabled = true;
        submit.textContent = 'Currently unavailable';
      }
    }

    wireStepper(picker);
    form.addEventListener('submit', (event) => submitMultipleTravelers(form, event));
  }

  function initAll(root = document) {
    addStyles();
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll(FORM_SELECTOR).forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
